module.exports = __webpack_public_path__ + "img/web_single-bg.b0228f15.png";